import ajax from "../utils/request.js";
//系统管理

//产品线列表 get /api/products/lists
const productslists = (data) => {
  return ajax.get("/api/products/lists", data);
};
//删除产品线  POST /api/products/delete
const productsdelete = (data) => {
  return ajax.post("/api/products/delete", data);
};
//编辑产品线  POST /api/products/edit
const productsedit = (data) => {
  return ajax.post("/api/products/edit", data);
};
//编辑产品线  POST /api/products/editSort
const productseditSort = (data) => {
  return ajax.post("/api/products/editSort", data);
};
//添加产品线  POST /api/products/add
const productsadd = (data) => {
  return ajax.post("/api/products/add", data);
};
//导入产品线  POST /api/products/import --没有用了
const productsimport = (data) => {
  return ajax.post("/api/products/import", data);
};


//礼品分类管理
//礼品分类列表   get /api/categoryGift/lists
const categoryGiftlists = (data) => {
  return ajax.get("/api/categoryGift/lists", data);
};
//添加礼品分类 post /api/categoryGift/add
const categoryGiftadd = (data) => {
  return ajax.post("/api/categoryGift/add", data);
};
//删除礼品分类  post /api/categoryGift/delete
const categoryGiftdelete = (data) => {
  return ajax.post("/api/categoryGift/delete", data);
};
//编辑礼品分类  post /api/categoryGift/edit
const categoryGiftedit = (data) => {
  return ajax.post("/api/categoryGift/edit", data);
};

//banner 管理
//banner列表 get /api/banner/lists
const bannerlists = (data) => {
  return ajax.get("/api/banner/lists", data);
};
//banner添加 post /api/banner/add
const banneradd = (data) => {
  return ajax.post("/api/banner/add", data);
};
//编辑状态 post /banner/editStatus
const bannereditStatus = (data) => {
  return ajax.post("/api/banner/editStatus", data);
};
//删除banner post /banner/delete
const bannerdelete = (data) => {
  return ajax.post("/api/banner/delete", data);
};
//编辑banner post /banner/edit
const banneredit = (data) => {
  return ajax.post("/api/banner/edit", data);
};

//推荐位管理
// 推荐位列表？ get /api/recommend/lists
const recommendlists = (data) => {
  return ajax.get("/api/recommend/lists", data);
};

//底部栏目管理  get /api/categoryLinks/lists
const categoryLinkslists = (data) => {
  return ajax.get("/api/categoryLinks/lists", data);
};
//添加底部栏目管理  post /api/categoryLinks/add
const categoryLinksadd = (data) => {
  return ajax.post("/api/categoryLinks/add", data);
};
//编辑底部栏目管理  post /api/categoryLinks/edit
const categoryLinksedit = (data) => {
  return ajax.post("/api/categoryLinks/edit", data);
};
//删除底部栏目管理  post /api/categoryLinks/delete
const categoryLinksdelete = (data) => {
  return ajax.post("/api/categoryLinks/delete", data);
};

//底部链接管理
//链接列表 get /api/links/lists
const linkslists = (data) => {
  return ajax.get("/api/links/lists", data);
};
//删除链接  post /api/links/delete
const linksdelete = (data) => {
  return ajax.post("/api/links/delete", data);
};
//添加链接  post /api/links/add
const linksadd = (data) => {
  return ajax.post("/api/links/add", data);
};
//编辑链接  post /api/links/edit
const linksedit = (data) => {
  return ajax.post("/api/links/edit", data);
};

//角色管理
//角色列表  get /api/role/lists
const rolelists = (data) => {
  return ajax.get("/api/role/lists", data);
};
//添加角色  post /api/role/add
const roleadd = (data) => {
  return ajax.post("/api/role/add", data);
};
//编辑角色  post /api/role/edit
const roleedit = (data) => {
  return ajax.post("/api/role/edit", data);
};
//删除角色  post /api/role/delete
const roledelete = (data) => {
  return ajax.post("/api/role/delete", data);
};
//角色全部权限  get /api/role/rules
const rolerules = (data) => {
  return ajax.get("/api/role/rules", data);
};


//员工后台用户
//列表  get /api/admin/lists
const adminlists = (data) => {
  return ajax.get("/api/admin/lists", data);
};
//员工角色  get /api/admin/roles
const adminroles = (data) => {
  return ajax.get("/api/admin/roles", data);
};
//新增  post /api/admin/add
const adminadd = (data) => {
  return ajax.post("/api/admin/add", data);
};
//编辑  post /api/admin/edit
const adminedit = (data) => {
  return ajax.post("/api/admin/edit", data);
};
//删除  post /api/admin/delete
const admindelete = (data) => {
  return ajax.post("/api/admin/delete", data);
};

//版权协议
//信息查询 get /config/info
const configinfo = (data) => {
  return ajax.get("/api/config/info", data);
};
//信息修改 post /config/save
const configedit = (data) => {
  return ajax.post("/api/config/save", data);
};

//积分领取记录和礼品领取记录详情  get  /api/web/detailIntegral/lists   1=积分 2=兑换
const orderDetail = (data) => {
  return ajax.get("/api/detailIntegral/orderDetail", data);
};
export {
  productslists,
  productsedit,
  productseditSort,
  productsdelete,
  productsadd,
  productsimport,
  categoryGiftlists,
  categoryGiftadd,
  categoryGiftdelete,
  categoryGiftedit,
  bannerlists,
  banneradd,
  recommendlists,
  bannereditStatus,
  banneredit,
  bannerdelete,
  categoryLinkslists,
  categoryLinksadd,
  categoryLinksedit,
  categoryLinksdelete,
  linkslists,
  linksdelete,
  linksadd,
  linksedit,
  rolelists,
  roleadd,
  rolerules,
  roleedit,
  roledelete,
  adminlists,
  adminadd,
  admindelete,
  adminroles,
  adminedit,
  configinfo,
  configedit,
  orderDetail
}
